import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useCallback, useRef, useState } from 'react';
import { Message } from '../../primitives/internal/Message/index.js';
import { Container } from '../../primitives/TextInput/components/Container.js';
import { Icon } from '../../primitives/TextInput/components/Icon.js';
import { Label } from '../../primitives/TextInput/components/Label.js';
import { MaskedInput } from '../../primitives/TextInput/components/MaskedInput.js';
import { Wrapper } from '../../primitives/TextInput/components/Wrapper.js';
export const MaskedField = /*#__PURE__*/_styled(forwardRef(function MaskedField({
  id,
  label,
  message,
  placeholder = ' ',
  disabled,
  invalid,
  fullWidth,
  visuallyFocused,
  className,
  appendIcon,
  prependIcon,
  onFocus,
  onBlur,
  size = 'medium',
  variant = 'info',
  allowOverflow,
  type = 'text',
  ...restProps
}, ref) {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  const handleFocus = useCallback(event => {
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  }, [onBlur]);
  const handleIconClick = useCallback(() => {
    if (focused) {
      inputRef.current?.blur();
    } else {
      inputRef.current?.focus();
    }
  }, [focused, inputRef]);
  return _jsxs(Wrapper, {
    fullWidth: fullWidth,
    ref: ref,
    children: [_jsxs(Container, {
      size: size,
      className: className,
      invalid: invalid,
      disabled: disabled,
      focused: focused || !!visuallyFocused,
      variant: variant,
      children: [prependIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        "data-testid": "textfield-prepend-icon",
        children: prependIcon
      }), _jsx(MaskedInput, {
        ...restProps,
        type: type,
        id: id,
        placeholder: placeholder,
        size: size,
        allowOverflow: allowOverflow,
        disabled: disabled,
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-invalid": invalid,
        "aria-describedby": message ? `${id}-message` : undefined
      }), placeholder === ' ' && _jsx(Label, {
        tabIndex: -1,
        "data-testid": "label",
        disabled: disabled,
        htmlFor: id,
        children: label
      }), appendIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        children: appendIcon
      })]
    }), message && _jsx(Message, {
      "data-testid": "message",
      invalid: invalid,
      id: `${id}-message`,
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1magum90"
} : {
  target: "e1magum90",
  label: "MaskedField"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1hc2tlZEZpZWxkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlDSSIsImZpbGUiOiJNYXNrZWRGaWVsZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmLCB1c2VDYWxsYmFjaywgdXNlUmVmLCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IE1lc3NhZ2UgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL2ludGVybmFsL01lc3NhZ2UvaW5kZXguanMnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9UZXh0SW5wdXQvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgSWNvbiB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvVGV4dElucHV0L2NvbXBvbmVudHMvSWNvbi5qcyc7XG5pbXBvcnQgeyBMYWJlbCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvVGV4dElucHV0L2NvbXBvbmVudHMvTGFiZWwuanMnO1xuaW1wb3J0IHsgTWFza2VkSW5wdXQgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1RleHRJbnB1dC9jb21wb25lbnRzL01hc2tlZElucHV0LmpzJztcbmltcG9ydCB7IFdyYXBwZXIgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1RleHRJbnB1dC9jb21wb25lbnRzL1dyYXBwZXIuanMnO1xuZXhwb3J0IGNvbnN0IE1hc2tlZEZpZWxkID0gc3R5bGVkKGZvcndhcmRSZWYoZnVuY3Rpb24gTWFza2VkRmllbGQoeyBpZCwgbGFiZWwsIG1lc3NhZ2UsIHBsYWNlaG9sZGVyID0gJyAnLCBkaXNhYmxlZCwgaW52YWxpZCwgZnVsbFdpZHRoLCB2aXN1YWxseUZvY3VzZWQsIGNsYXNzTmFtZSwgYXBwZW5kSWNvbiwgcHJlcGVuZEljb24sIG9uRm9jdXMsIG9uQmx1ciwgc2l6ZSA9ICdtZWRpdW0nLCB2YXJpYW50ID0gJ2luZm8nLCBhbGxvd092ZXJmbG93LCB0eXBlID0gJ3RleHQnLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSB7XG4gICAgY29uc3QgW2ZvY3VzZWQsIHNldEZvY3VzZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuICAgIGNvbnN0IGlucHV0UmVmID0gdXNlUmVmKG51bGwpO1xuICAgIGNvbnN0IGhhbmRsZUZvY3VzID0gdXNlQ2FsbGJhY2soKGV2ZW50KSA9PiB7XG4gICAgICAgIGlmIChvbkZvY3VzKSB7XG4gICAgICAgICAgICBvbkZvY3VzKGV2ZW50KTtcbiAgICAgICAgfVxuICAgICAgICBzZXRGb2N1c2VkKHRydWUpO1xuICAgIH0sIFtvbkZvY3VzXSk7XG4gICAgY29uc3QgaGFuZGxlQmx1ciA9IHVzZUNhbGxiYWNrKChldmVudCkgPT4ge1xuICAgICAgICBpZiAob25CbHVyKSB7XG4gICAgICAgICAgICBvbkJsdXIoZXZlbnQpO1xuICAgICAgICB9XG4gICAgICAgIHNldEZvY3VzZWQoZmFsc2UpO1xuICAgIH0sIFtvbkJsdXJdKTtcbiAgICBjb25zdCBoYW5kbGVJY29uQ2xpY2sgPSB1c2VDYWxsYmFjaygoKSA9PiB7XG4gICAgICAgIGlmIChmb2N1c2VkKSB7XG4gICAgICAgICAgICBpbnB1dFJlZi5jdXJyZW50Py5ibHVyKCk7XG4gICAgICAgIH1cbiAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICBpbnB1dFJlZi5jdXJyZW50Py5mb2N1cygpO1xuICAgICAgICB9XG4gICAgfSwgW2ZvY3VzZWQsIGlucHV0UmVmXSk7XG4gICAgcmV0dXJuIChfanN4cyhXcmFwcGVyLCB7IGZ1bGxXaWR0aDogZnVsbFdpZHRoLCByZWY6IHJlZiwgY2hpbGRyZW46IFtfanN4cyhDb250YWluZXIsIHsgc2l6ZTogc2l6ZSwgY2xhc3NOYW1lOiBjbGFzc05hbWUsIGludmFsaWQ6IGludmFsaWQsIGRpc2FibGVkOiBkaXNhYmxlZCwgZm9jdXNlZDogZm9jdXNlZCB8fCAhIXZpc3VhbGx5Rm9jdXNlZCwgdmFyaWFudDogdmFyaWFudCwgY2hpbGRyZW46IFtwcmVwZW5kSWNvbiAmJiAoX2pzeChJY29uLCB7IG9uQ2xpY2s6IGhhbmRsZUljb25DbGljaywgc2l6ZTogc2l6ZSwgXCJkYXRhLXRlc3RpZFwiOiBcInRleHRmaWVsZC1wcmVwZW5kLWljb25cIiwgY2hpbGRyZW46IHByZXBlbmRJY29uIH0pKSwgX2pzeChNYXNrZWRJbnB1dCwgeyAuLi5yZXN0UHJvcHMsIHR5cGU6IHR5cGUsIGlkOiBpZCwgcGxhY2Vob2xkZXI6IHBsYWNlaG9sZGVyLCBzaXplOiBzaXplLCBhbGxvd092ZXJmbG93OiBhbGxvd092ZXJmbG93LCBkaXNhYmxlZDogZGlzYWJsZWQsIG9uRm9jdXM6IGhhbmRsZUZvY3VzLCBvbkJsdXI6IGhhbmRsZUJsdXIsIFwiYXJpYS1pbnZhbGlkXCI6IGludmFsaWQsIFwiYXJpYS1kZXNjcmliZWRieVwiOiBtZXNzYWdlID8gYCR7aWR9LW1lc3NhZ2VgIDogdW5kZWZpbmVkIH0pLCBwbGFjZWhvbGRlciA9PT0gJyAnICYmIChfanN4KExhYmVsLCB7IHRhYkluZGV4OiAtMSwgXCJkYXRhLXRlc3RpZFwiOiBcImxhYmVsXCIsIGRpc2FibGVkOiBkaXNhYmxlZCwgaHRtbEZvcjogaWQsIGNoaWxkcmVuOiBsYWJlbCB9KSksIGFwcGVuZEljb24gJiYgKF9qc3goSWNvbiwgeyBvbkNsaWNrOiBoYW5kbGVJY29uQ2xpY2ssIHNpemU6IHNpemUsIGNoaWxkcmVuOiBhcHBlbmRJY29uIH0pKV0gfSksIG1lc3NhZ2UgJiYgKF9qc3goTWVzc2FnZSwgeyBcImRhdGEtdGVzdGlkXCI6IFwibWVzc2FnZVwiLCBpbnZhbGlkOiBpbnZhbGlkLCBpZDogYCR7aWR9LW1lc3NhZ2VgLCBjaGlsZHJlbjogbWVzc2FnZSB9KSldIH0pKTtcbn0pKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPU1hc2tlZEZpZWxkLmpzLm1hcCJdfQ== */");